import { RequirementsTable } from "../../../Requirements/components/RequirementsTable";
import { RequirementContextType } from "../../../Requirements/types";
import {
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_PAYEE } from "../../index";
import { useRequirementInstructionsModal } from "../../../Requirements/components/RequirementsDetails/useRequirementInstructionsModal";
import { selectorIsInstructionsModalAvailable } from "../../../Requirements/selectors/selectorIsInstructionsModalAvailable";

export const PayerRequirements: React.FC<{
  requirements: IRequirementResponse[];
}> = ({ requirements }) => {
  const history = useHistory();
  const requirementInstructionsModal = useRequirementInstructionsModal();

  return (
    <RequirementsTable
      requiredAction="Start"
      onViewDetails={async (requirement, additionalData) => {
        if (requirement.status !== RequirementStatus.Complete) {
          if (
            selectorIsInstructionsModalAvailable(requirement, additionalData)
          ) {
            const instructionsResult = await requirementInstructionsModal.open({
              requirementId: requirement.requirementId
            });

            if (instructionsResult !== true) return;
          }
        }

        history.push(
          `${PATH_ONBOARDING_PAYEE}/requirements/${requirement.requirementId}/details`
        );
      }}
      contextType={RequirementContextType.Payer}
      requirements={requirements}
    />
  );
};
